var map = {
	"./100k/level-1.png": "94db",
	"./10k/level-1.png": "1d9e",
	"./200k/level-1.png": "5760",
	"./25k/level-1.png": "8fad",
	"./300k/level-1.png": "b517",
	"./50k/level-1.png": "b0ca"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d298";